// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__GbsJ1","load":"Spinner_load__Bo1Mz"};